import { FieldPropsType } from '@interfaces/commons/FieldPropsType'
import { Field } from 'formik'
import React from 'react'
import { SelectButtonAcceptProps, SelectButtonProps } from './interface'

const withSelectButton = (Component: React.FC<SelectButtonProps>) => {
  function Hoc({ name, onChange, ...props }: SelectButtonAcceptProps) {
    return (
      <Field name={name}>
        {({ field, meta, form }: FieldPropsType<any>) => (
          <Component
            {...props}
            value={field.value}
            onChange={value => {
              form.setFieldValue(name, value)
              setTimeout(() => {
                form.setFieldTouched(name, true)
              })
              if (onChange) {
                onChange(value)
              }
            }}
          />
        )}
      </Field>
    )
  }

  return Hoc
}

export { withSelectButton }
